<template>
  <div class="classmodal_content">
    <a-row :gutter="20" style="display: flex; margin-bottom: 10px;">
      <a-col :span="24">
        <a-row style="display: flex;">
          <a-col :span="6" >
            <a-time-picker
              :disabled="disabled"
              :value="startTime"
              placeholder="开始时间"
              format="HH:mm"
              :disabledHours="disabledStartHours"
              :disabledMinutes="disabledStartMinutes"
              @change="changeStartTime"
            />
          </a-col>
          <a-col :span="6" >
            <a-time-picker
              :disabled="disabled"
              :value="endTime"
              placeholder="结束时间"
              format="HH:mm"
              :disabledHours="disabledEndHours"
              :disabledMinutes="disabledEndMinutes"
              @change="changeEndTime"
            />
          </a-col>
          <a-col :span="12" >
            <a-date-picker :showToday="false"
              :disabled="disabled"
              :value="date"
              @change="handleLiveDateChange"
              :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
            />
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <div class="error-tip" v-show="showError">请填写有效的授课时间</div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'CourseDateSingle', // 巡视备注组件
  props: {
    disabled: Boolean,
    showDateError: Boolean,
    liveTimeObj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    showDateError(nVal) {
      this.showError = nVal
    }
  },
  components: {
  },
  data() {
    const { startTime, endTime } = this.liveTimeObj
    return {
      showError: false,
      startTime: startTime ? moment(startTime) : null,
      endTime: endTime ? moment(endTime) : null,
      date: startTime ? moment(startTime) : null // 日期
    }
  },
  methods: {
    moment,
    checkTime() {
      const { startTime, endTime, date } = this
      this.showError = !startTime || !endTime || !date
    },
    changeStartTime(value) {
      this.startTime = value
      this.changeTimeList()
    },
    changeEndTime(value) {
      this.endTime = value
      this.changeTimeList()
    },
    handleLiveDateChange(date) {
      this.date = date
      this.changeTimeList()
    },
    changeTimeList() {
      const { startTime, endTime, date } = this
      const timeObj = {
        startDateTime: (startTime && date ) ? moment(date).format('YYYY-MM-DD') + ' ' + moment(startTime).format('HH:mm') : '',
        endDateTime: (endTime && date ) ? moment(date).format('YYYY-MM-DD') + ' ' + moment(endTime).format('HH:mm') : ''
      }
      this.checkTime()
      this.$emit('changeTimeObj', timeObj)
    },
    disabledStartHours() {
      if(this.endTime){
        let hours = [];
        let hour = moment(this.endTime).hour();
        for (let i = hour+1; i < 24; i++) {
          hours.push(i);
        }
        return hours
      }
    },
    disabledStartMinutes(selectedHour) {
      if(this.endTime){
        let minutes = [];
        let hour = moment(this.endTime).hour();
        let minute = moment(this.endTime).minute();
        if(selectedHour===hour){
          for (let i = minute+1; i < 60; i++) {
            minutes.push(i);
          }
        }
        return minutes
      }
    },
    disabledEndHours() {
      if(this.startTime){
        let hours = [];
        let hour = moment(this.startTime).hour();
        for (let i = 0; i < hour; i++) {
          hours.push(i);
        }
        return hours
      }
    },
    disabledEndMinutes(selectedHour) {
      if(this.startTime){
        let minutes = [];
        let hour = moment(this.startTime).hour();
        let minute = moment(this.startTime).minute();
        if(selectedHour===hour){
          for (let i = 0; i < minute; i++) {
            minutes.push(i);
          }
        }
        return minutes
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.ant-time-picker{
  width: 90%;
}
.ant-calendar-picker{
  width: 100%;
}
.classmodal_content {
  .error-tip{
    color: #f5222d;
  }
}
</style>